import {createContext, useContext, useEffect, useReducer} from "react";
import {initialState, reducer, setGoodsList, setLoading, setQuery, setTotal, setSortTypeActive} from "./reducer";
import {useQryShopProdItemPage} from "../../../api/shopProdItem";
import {useNavigateTo} from "../../../hooks/useNavigateTo";
import {mediaMatch} from "../../../utils";

const Context = createContext(initialState);

function SearchGoodsPageController() {
  const { state, dispatch } = useSearchGoodsPageContext();
  const { loading, getList } = useQryShopProdItemPage();
  const navigateTo = useNavigateTo();
  const isMdmax = mediaMatch.isMdmax;
  
  /**
   * 跳转到 商品详情
   * @param id
   */
  const gotoProductDetail = (id) => {
    if (isMdmax) {
      navigateTo(`/goodsDetail?goodsId=${id}`);
    } else {
      window.open(`${window.location.origin}/#/goodsDetail?goodsId=${id}`);
    }
  };
  
  /**
   * 获取商品列表
   * @param query
   * @returns {Promise<void>}
   */
  const getGoodsList = async (query) => {
    let q = {
      ...state.query,
      ...query
    };
    
    if (query && query.sortType) {
      delete q.shopType;
    }
    
    if (query && query.shopType) {
      delete q.sortType;
      delete q.sortKey;
    }
    
    let { data } = await getList(q);
    if (data) {
      dispatch(setGoodsList(data.records));
      dispatch(setTotal(data.total));
      dispatch(setQuery(q));
    }
  };
  
  const searchSortType = (query, i) => {
    getGoodsList(query);
    dispatch(setSortTypeActive(i));
  };
  
  useEffect(() => {
    dispatch(setLoading(loading));
  }, [loading]);
  
  return {
    loading,
    getGoodsList,
    searchSortType,
    gotoProductDetail
  };
  
}

function useSearchGoodsPageContext() {
  const { state, dispatch } = useContext(Context);
  
  return {
    state,
    dispatch,
  };
}

export {useSearchGoodsPageContext, SearchGoodsPageController};

export default function SearchGoodsPageContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  return (
    <Context.Provider
      value={{ state, dispatch }}
      initialState={initialState}
      reducer={reducer}>
      {children}
    </Context.Provider>
  );
}
